module.exports = __webpack_public_path__ + "img/images.d1672055.svg";